// TODO: Narrow down types of `fieldType` and `type`

export default class FormField {
  constructor(props = {}) {
    var _props$isCustom, _props$isRequired, _props$label, _props$name;
    this.fieldType = props.fieldType !== undefined ? props.fieldType : null;
    this.isCustom = (_props$isCustom = props.isCustom) !== null && _props$isCustom !== void 0 ? _props$isCustom : true;
    this.isRequired = (_props$isRequired = props.isRequired) !== null && _props$isRequired !== void 0 ? _props$isRequired : true;
    this.label = (_props$label = props.label) !== null && _props$label !== void 0 ? _props$label : '';
    this.name = (_props$name = props.name) !== null && _props$name !== void 0 ? _props$name : '';
    this.numberDisplayHint = props.numberDisplayHint !== undefined ? props.numberDisplayHint : null;
    // LinkCustomParams (still ImmutableJS, Phase 4) may pass options as a
    // List<ImmutableMap> (from ContactPropertyForm via selectedProperty.get('options')).
    // Call .toJS() to get plain FormFieldOption objects; fall back to Array.from for
    // other iterables.
    const rawOptions = props.options;
    if (rawOptions == null) {
      this.options = [];
    } else if (Array.isArray(rawOptions)) {
      this.options = rawOptions;
    } else if (typeof rawOptions.toJS === 'function') {
      this.options = rawOptions.toJS();
    } else {
      this.options = Array.from(rawOptions);
    }
    this.type = props.type !== undefined ? props.type : null;
  }
  static from(json) {
    return new FormField(json);
  }
  static add(isCustom, name, label, numberDisplayHint = null, fieldData = {}) {
    return new FormField(Object.assign({
      isCustom,
      name,
      label,
      numberDisplayHint
    }, fieldData));
  }
  toJSON() {
    return {
      fieldType: this.fieldType,
      isCustom: this.isCustom,
      isRequired: this.isRequired,
      label: this.label,
      name: this.name,
      numberDisplayHint: this.numberDisplayHint,
      options: this.options,
      type: this.type
    };
  }

  // Required so ImmutableJS List.toJS() recurses into FormField instances
  // when MeetingsLink.toJS() serializes the link for the preview iframe.
  toJS() {
    return this.toJSON();
  }
}